<template>
  <div class="dropdown" @mousedown="(e) => e.preventDefault()">
    <div class="dropdown-header">
      <a-checkbox
        class="title"
        @change="handleChangeAll"
        v-model:checked="allChecked"
      ></a-checkbox>
      <span class="title-label" @click="handleChangeAll">
        {{ title }}
      </span>
    </div>
    <div class="dropdown-list">
      <div v-for="(item, index) in list" :key="item">
        <div class="dropdown-list-sub-title">
          <a-checkbox
            v-model:checked="checkeds[index]"
            @change="handleChangeSubAll(index)"
          ></a-checkbox>
          <span
            class="dropdown-list-sub-title-label"
            @click="handleChangeSubAll(index)"
          >
            {{ item.name }}
          </span>
        </div>
        <a-checkbox-group v-model:value="values[index]">
          <div
            v-for="opt in item.children"
            :key="opt"
            class="dropdown-list-item"
          >
            <a-checkbox
              :value="opt"
              class="dropdown-list-item-checkbox"
            ></a-checkbox>
            <span
              class="dropdown-list-item-label"
              @click="handleClickCheckboxLabel(opt, index)"
            >
              {{ opt }}
            </span>
          </div>
        </a-checkbox-group>
      </div>
    </div>
    <div class="dropdown-actions">
      <a-button type="link" class="clear" @click="handleClear">
        Clear All
      </a-button>
      <a-button class="cancel" @click="handleCancel">Cancel</a-button>
      <a-button type="primary" @click="handleApply">Apply</a-button>
    </div>
  </div>
</template>

<script>
  import { toRaw } from 'vue'
  export default {
    name: 'DashboardTreeDropdownRender',
    props: {
      title: {
        type: String,
      },
      list: {
        type: Array,
      },
      type: {
        type: String,
      },
      selected: {
        type: Array,
      },
    },
    data() {
      return {
        values: [],
        checkeds: [],
      }
    },
    mounted() {
      this.values = this.list.map((e) => {
        return e.children.filter((child) => this.selected.includes(child))
      })
      this.checkeds = this.values.map(() => false)
    },
    computed: {
      options() {
        return this.list.map((el) => ({ label: el.name, value: el }))
      },
      allChecked() {
        const len = this.list
          .map((e) => e.children.length)
          .reduce((prev, next) => prev + next, 0)

        const vLen = this.values
          .map((e) => e.length)
          .reduce((prev, next) => prev + next, 0)

        return vLen === len
      },
    },
    watch: {
      values: {
        handler(newVal) {
          this.checkeds = this.list.map((_, index) => {
            return this.list[index].children.length === newVal[index].length
          })
        },
        deep: true,
      },
      selected: {
        handler(val) {
          this.values = this.list.map((e) => {
            return e.children.filter((child) => val.includes(child))
          })
        },
      },
    },
    methods: {
      handleChangeAll() {
        if (!this.allChecked) {
          this.values = this.list.map((e) => e.children)
        } else {
          this.values = this.list.map(() => [])
        }
      },
      handleChangeSubAll(index) {
        if (this.list[index].children.length === this.values[index].length) {
          this.values[index] = []
        } else {
          this.values[index] = this.list[index].children
        }
      },
      handleClear() {
        this.values = this.list.map(() => [])
      },
      handleCancel() {
        this.$emit('cancel', false, this.type)
      },
      handleApply() {
        const value = this.values.reduce((prev, next) => prev.concat(next), [])
        this.$emit('query', value, this.type)
      },
      handleClickCheckboxLabel(opt, index) {
        if (this.values[index].includes(opt)) {
          this.values[index] = this.values[index].filter((e) => e !== opt)
        } else {
          this.values[index] = this.values[index].concat([opt])
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  .dropdown {
    &-header {
      .title {
        padding: 12px;

        &-label {
          font-weight: 700;
          font-size: 14px;
          color: black;
          cursor: pointer;
        }
      }
    }

    &-list {
      max-height: 300px;
      overflow-y: scroll;
      padding: 12px;

      &-sub-title {
        color: black;
        margin-bottom: 12px;

        &-label {
          margin-left: 12px;
          cursor: pointer;
          font-weight: normal;
        }
      }

      &-item {
        margin-bottom: 12px;
        margin-left: 12px;

        &-checkbox {
          margin-right: 12px;
        }

        &-label {
          cursor: pointer;
          font-weight: normal;
        }
      }
    }

    &-actions {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 12px;
      border-top: 1px solid #f0f0f0;

      .clear {
        margin-right: 16px;
      }

      .cancel {
        margin-right: 16px;
      }
    }
  }
</style>
